import { createIcon } from '@chakra-ui/icon'

export const AccreditedIcon = createIcon({
  displayName: 'StarOutlineIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8335 3.33337H4.16683C3.94582 3.33337 3.73385 3.42117 3.57757 3.57745C3.42129 3.73373 3.3335 3.94569 3.3335 4.16671V15.8334C3.3335 16.0544 3.42129 16.2663 3.57757 16.4226C3.73385 16.5789 3.94582 16.6667 4.16683 16.6667H15.8335C16.0545 16.6667 16.2665 16.5789 16.4228 16.4226C16.579 16.2663 16.6668 16.0544 16.6668 15.8334V4.16671C16.6668 3.94569 16.579 3.73373 16.4228 3.57745C16.2665 3.42117 16.0545 3.33337 15.8335 3.33337Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.3335 6.66663H16.6668"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6665 3.33337V6.66671"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9165 12.0834L9.1665 13.3334L11.6665 10.8334"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
})
